import bol from '../assets/avatar-placeholders/bol.png'
import coffee from '../assets/avatar-placeholders/coffee.png'
import man from '../assets/avatar-placeholders/man.png'
import woman from '../assets/avatar-placeholders/woman.png'
import woman2 from '../assets/avatar-placeholders/woman2.png'

/**
 * Serve PLACEHOLDER avatars from the bundle, not from OSS.
 *
 * `AvatarPlaceholderService` assigns everyone without a photo one of five
 * stock images, stored at `<bucket>/placeholders/<file>.png`. The exact same
 * five files are already in `src/assets/avatar-placeholders/` — so today the
 * app downloads from Shanghai something it is literally shipping.
 *
 * That is most of the avatars on screen right now, since almost nobody has
 * uploaded a real picture yet, and it is why a table of six took seconds to
 * fill in on every visit.
 *
 * Vite fingerprints these files and they inherit the bundle's immutable cache,
 * so after the first paint they cost nothing at all — no request, no
 * revalidation, no round trip. A REAL photo still comes from OSS, which is
 * what the Cache-Control header added in OssStorageService is for.
 *
 * Matched by filename rather than by full URL on purpose: the bucket, the
 * endpoint and the `?v=` stamp can all change, and the file name is the part
 * that actually identifies the image.
 */
const BUNDLED: Record<string, string> = {
  'bol.png': bol,
  'coffee.png': coffee,
  'man.png': man,
  'woman.png': woman,
  'woman2.png': woman2
}

export function resolveAvatar(url?: string | null): string {
  if (!url) return ''
  if (!url.includes('/placeholders/')) return url          // a real photo
  const file = url.split('/placeholders/')[1]?.split('?')[0]
  return (file && BUNDLED[file]) || url                    // unknown name: leave it alone
}

/** True when this is one of ours rather than a picture the member chose. */
export const isPlaceholderAvatar = (url?: string | null): boolean =>
  Boolean(url && url.includes('/placeholders/'))
